// src/AppInfoDynamic.jsx
import React, { useEffect, useState } from "react";
import { db } from "./firebaseConfig";
import {
  collection, addDoc, deleteDoc, doc, getDocs, orderBy, query,
  serverTimestamp, updateDoc
} from "firebase/firestore";
import {
  Box, Button, CircularProgress, IconButton, MenuItem, Paper, Stack,
  TextField, Typography
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import toast from "react-hot-toast";
import { Editor } from "@tinymce/tinymce-react";

export default function AppInfoDynamic() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const qy = query(collection(db, "app_info"), orderBy("createdAt", "asc"));
      const snap = await getDocs(qy);
      setItems(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    })();
  }, []);

  const addItem = async () => {
    const ref = await addDoc(collection(db, "app_info"), {
      label: "New Field", type: "text", value: "", createdAt: serverTimestamp()
    });
    setItems(prev => [...prev, { id: ref.id, label: "New Field", type: "text", value: "" }]);
  };

  const updateItem = async (id, data) => {
    await updateDoc(doc(db, "app_info", id), data);
    setItems(prev => prev.map(i => i.id === id ? { ...i, ...data } : i));
  };

  const deleteItem = async (id) => {
    if (!window.confirm("Delete this field?")) return;
    await deleteDoc(doc(db, "app_info", id));
    setItems(prev => prev.filter(i => i.id !== id));
  };

  if (loading) return <CircularProgress sx={{ m: 4 }} />;

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" fontWeight={700}>About / Info Editor</Typography>
        <Button onClick={addItem} startIcon={<AddCircleOutlineIcon />} variant="contained">
          Add Field
        </Button>
      </Stack>
      {items.map((item) => (
        <Paper key={item.id} sx={{ p: 2, mb: 2 }}>
          <Stack spacing={2}>
            <Stack direction="row" spacing={2}>
              <TextField label="Label" value={item.label}
                onChange={(e) => updateItem(item.id, { label: e.target.value })}
                fullWidth />
              <TextField label="Type" select value={item.type}
                onChange={(e) => updateItem(item.id, { type: e.target.value })}
                sx={{ width: 160 }}>
                <MenuItem value="text">Text</MenuItem>
                <MenuItem value="link">Link</MenuItem>
                <MenuItem value="textarea">Rich Text</MenuItem>
                <MenuItem value="phone">Phone</MenuItem>
              </TextField>
              <IconButton color="error" onClick={() => deleteItem(item.id)}><DeleteIcon /></IconButton>
            </Stack>
            {item.type === "textarea" ? (
              <Editor
                apiKey="no-api-key"
                value={item.value || ""}
                onEditorChange={(content) => updateItem(item.id, { value: content })}
                init={{
                  height: 200,
                  menubar: false,
                  plugins: ["link", "lists", "autolink"],
                  toolbar: "undo redo | bold italic underline | bullist numlist | link removeformat",
                }}
              />
            ) : (
              <TextField label="Value" value={item.value || ""}
                onChange={(e) => updateItem(item.id, { value: e.target.value })}
                fullWidth />
            )}
          </Stack>
        </Paper>
      ))}
    </Box>
  );
}
